import { Link } from 'react-router-dom';
import { allProjects } from '../../../mocks/projects';

export default function Projects() {
  const featuredProjects = allProjects.filter(p => p.featured).slice(0, 4);

  return (
    <section id="projects" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12 md:mb-16">
          <div className="text-orange-500 text-xs md:text-sm font-semibold mb-2 tracking-wide">CASOS DE ÉXITO</div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-2">
            Proyectos que Revolucionan
          </h2>
          <h3 className="text-2xl md:text-4xl lg:text-5xl font-light italic text-gray-700" style={{ fontFamily: 'serif' }}>
            la Producción Industrial
          </h3>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredProjects.map((project) => (
            <Link
              key={project.id}
              to={`/proyectos/${project.id}`}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer hover:-translate-y-2"
            >
              <div className="relative h-64 md:h-80 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-orange-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              
              <div className="p-5 md:p-6 bg-white">
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1">{project.title}</h3>
                <div className="flex items-center justify-between">
                  <p className="text-xs md:text-sm text-gray-500">{project.industry}</p>
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-gray-400 group-hover:text-orange-500 transition-colors"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/proyectos"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-orange-500 to-green-500 text-white text-sm font-semibold rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
          >
            Ver Todos los Proyectos
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
